import CryptoJS from "crypto-js";
import { API_CONFIG } from "../config/api";


export function generateURN() {
  const timestamp = Date.now().toString(); 
  const random = Math.floor(100 + Math.random() * 900).toString(); 
  return timestamp + random; 
}

export function generateAuthToken(urn,user="") {
  let keyForHashing="";
  let basicAuthForHashing=""
  if(user==="admin"){
  keyForHashing=API_CONFIG.hmac.HASHKEY_ADMIN;
  basicAuthForHashing=API_CONFIG.basic.BASIC_AUTH_ADMIN;
  }
  else{
  keyForHashing=API_CONFIG.hmac.HASHKEY_CW_USER;
  basicAuthForHashing=API_CONFIG.basic.BASIC_AUTH_CWUSER;
  }
  const dataForHashing = `${basicAuthForHashing}#${urn}`;
  return CryptoJS.HmacSHA512(dataForHashing, keyForHashing).toString(CryptoJS.enc.Hex);
}

